import { CustomerLocation } from "../models/Booking/CustomerLocation";
import { CreditCard } from "../models/Booking/CreditCard";
import { Customer } from "../models/Booking/Customer";
import Api from "./api";

interface IAxiosCustomer {
    data: Customer
}

export class CustomerActions {
    static create(customer: Customer): Promise<IAxiosCustomer> {
        return Api.post("/customers", customer)
    }
    static update(customerId: number, customer: Customer): Promise<IAxiosCustomer> {
        return Api.put("/customers/"+customerId, customer)
    }
    static get(customerId:number): Promise<Customer> {
        return Api.get("/customers/"+customerId)
        .then((res:any)=> {return res.data} )
    }
    static getByName(name : string): Promise<Customer[]> {
        return Api.get(`search?q=${name}`).then( ( res : any ) => {
            return (res.data || []).sort((a : any, b : any) => {
                if ( a.prime_member === true && b.prime_member === false ) { return -1; }
                if ( a.prime_member === false && b.prime_member === true ) { return 1; }
                return 0;
            });
        } )
    }
    static getCards(customerId: number): Promise<CreditCard[]> {
        return Api.get("/credit_cards/"+customerId)
        .then((res:any)=> {return res.data} )
    }

    static createCard(customerId: number, card:CreditCard): Promise<CreditCard> {
        return Api.post("/credit_cards/"+customerId, card)
        .then((res:any)=> {return res.data} )
    }

    static CheckCvc(cardId: number, cvc:string): Promise<boolean> {
        return Api.get("/credit_cards/"+cardId+"/check?cvc="+cvc)
        .then((res:any)=> {return res.data.success} )
    }

    static getLeads(customerId: number): Promise<any[]> {
        return Api.get("/leads/"+customerId)
        .then((res:any)=> {return res.data} )
    }

    static createLocation(customerId:number, location: CustomerLocation){
        return Api.post("/customers/"+customerId+'/locations', location)
        .then((res:any)=> {return res.data} )
    } 
    static updateLocation(id:number, location: CustomerLocation){
        return Api.patch("/customer_locations/"+id, location)
        .then((res:any)=> {return res.data} )
    }
    static getBenefits(customerId: number): Promise<any> {
        return Api.get("/customers/benefits/"+customerId)
            .then((res:any)=> {return res.data} )
    }
}